module.exports = __webpack_public_path__ + "assets/f20c724d442076cc6e9c114086bc08ac.svg";